"use strict";
const _ = require('lodash');
const alert = require('./alert/alert.const.translate');
const article = require('./article/article.const.translate');
const articlePlural = require('./article/article.const.plural');
const brand = require('./brand/brand.const.translate');
const customerSubUnit = require('./customerSubUnit/customerSubUnit.const.translate');
const supplierCustomer = require('./supplierCustomer/supplierCustomer.const.translate');
const invite = require('./invite/invite.const.translate');
const invoice = require('./invoice/invoice.const.translate');
const order = require('./order/order.const.translate');
const organization = require('./organization/organization.const.translate');
const priceList = require('./priceList/priceList.const.translate');
const purchaseOrder = require('./purchaseOrder/purchaseOrder.const.translate');
const shopConfig = require('./shopConfig/shopConfig.const.translate');
const supplier = require('./supplier/supplier.const.translate');
const supplierSalesReport = require('./supplierSalesReport/supplierSalesReport.const.translate');
const settlement = require('./settlement/settlement.const.translate');
const entitySettlement = require('./entitySettlement/entitySettlement.const.translate');
const shopUser = require('./shopUser/shopUser.const.translate');
const user = require('./user/user.const.translate');
const stockTaking = require('./stockTaking/stockTaking.const.translate');
const job = require('./job/job.const.translate');
const complaint = require('./complaint/complaint.const.translate');
const outgoingMessage = require('./outgoingMessage/outgoingMessage.const.translate');
const incomingMessage = require('./incomingMessage/incomingMessage.const.translate');
const failedActionCall = require('./failedActionCall/failedActionCall.const.translate');
const emailTemplateConfig = require('./emailTemplateConfig/emailTemplateConfig.const.translate');
const copackAgreement = require('./copackAgreement/copackAgreement.const.translate');
const alcoholLicense = require('./alcoholLicense/alcoholLicense.const.translate');
const integration = require('./integration/integration.const.translate');
const plurals = {
    article: articlePlural,
};
const translations = {
    order,
    article,
    customerSubUnit,
    supplierCustomer,
    purchaseOrder,
    alert,
    brand,
    invite,
    invoice,
    organization,
    priceList,
    shopConfig,
    shopUser,
    supplier,
    supplierSalesReport,
    settlement,
    entitySettlement,
    user,
    job,
    complaint,
    outgoingMessage,
    incomingMessage,
    failedActionCall,
    stockTaking,
    emailTemplateConfig,
    copackAgreement,
    alcoholLicense,
    integration,
};
const getTranslation = (first, second) => {
    if (_.startsWith(first, 'pricedArticle.')) {
        const newfirst = first.replace('pricedArticle.', 'article.');
        return getTranslation(newfirst, second);
    }
    if (second === undefined) {
        // second === null is a normal case.
        const translation = _.get(translations, first, first.split('.').pop());
        if (translation === null) {
            return '';
        }
        return translation;
    }
    const translation = _.get(translations, `${first}.${second}`, second);
    if (translation === null) {
        return '';
    }
    return translation;
};
const getTranslationWithEntityName = (first, second) => {
    const entityName = _.first(first.split('.'));
    const translatedEntity = getTranslation(entityName, entityName);
    const translatedKey = getTranslation(first, second);
    return `${translatedEntity} ${translatedKey}`;
};
const getPluralization = (first, second) => {
    if (_.startsWith(first, 'pricedArticle.')) {
        const newfirst = first.replace('pricedArticle.', 'article.');
        return getPluralization(newfirst, second);
    }
    if (second === undefined) {
        // second === null is a normal case.
        const plural = _.get(plurals, first, first.split('.').pop());
        if (plural === null) {
            return '';
        }
        return plural;
    }
    const plural = _.get(plurals, `${first}.${second}`, second);
    if (plural === null) {
        return '';
    }
    return plural;
};
module.exports = {
    getTranslation,
    getTranslationWithEntityName,
    getPluralization,
};
